import TextField from "../../../../components/fields/textField/TextField.vue";
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import {SnackBarModule} from "@/modules/SnackBarModule";
import moment from "moment";


export default {
    name: "ComparativoDialog",
    components: {
        TextField,
        ConfirmPasswordDialog,
        FormDialog,
        SnackBarModule
    },
    mixins:[AssinaturaMixin,SnackbarMixin ],
    props: {
        activeDialog: {
            type: Boolean,
            default: false,
        },
        matricula: {
            required: true,
        },
        comparativo: {
            required: true,
        },
        comparativo_b: {
        },
    },
    data: () => ({
        tableCargos: [
            { text: "Cargo", value: "nome", sortable: false },
            { text: "", value: "atribuir", sortable: false, width: "100" },
        ],
        data: [],
        errors: [],
        boletim:0,
        disabled: {
            nome: false,
            cargos: false,
        },
        form: {},
        formValid: true,
        loading: {
            table: false,
            divergencia:false
        },
        page: 1,
        meses:[
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez'],
        pageCount: 0,
        itemsPerPage: 10,
        search: "",
        showFormDialog: false,
        activeBtnDialog:false,
        showDialogConfirmPassword: false,
        formConfirmPassword: {
            justificativa:"",
            password:""
        },
        send: {
            function: () => {},
            params: null,
        },

        cargos: [],
    }),

    watch: {
        activeDialog() {
            if (this.comparativo) {
                this.showFormDialog = !this.showFormDialog;

               // console.log(this.comparativo)
            }
        },
    },

    created() {
        this.getDivergencia();
    },

    methods: {
        goTo(path) {
            this.$router.push(path);
        },

        async getDivergencia() {
            console.log(this.comparativo_b);
            moment.locale('pt')
            this.boletim = 'BE'+moment().format('dMMMy')
        },

    },
};
